const COLOR_CLASS_MAP = {
    green: {
        row: 'bg-green-50',
        cell: 'text-green-700',
        soft: 'bg-green-100 text-green-900',
        indicator: 'bg-green-100 text-green-900'
    },
    red: {
        row: 'bg-red-50',
        cell: 'text-red-700',
        soft: 'bg-red-100 text-red-900',
        indicator: 'bg-red-100 text-red-900'
    },
    yellow: {
        row: 'bg-yellow-50',
        cell: 'text-yellow-700',
        soft: 'bg-amber-100 text-amber-900',
        indicator: 'bg-amber-100 text-amber-900'
    },
    gray: {
        row: 'bg-gray-50',
        cell: 'text-gray-700',
        soft: 'bg-gray-100 text-gray-900',
        indicator: 'bg-gray-100 text-gray-900'
    }
};

export function getColorClass(color, variant = 'cell', fallback = '') {
    if (!color) { return fallback; }
    return COLOR_CLASS_MAP[color]?.[variant] || fallback;
}

export function getSoftStatusClass(color, fallback = 'bg-gray-100 text-gray-900') {
    return getColorClass(color, 'soft', fallback);
}

export function getIndicatorColorClass(color, fallback = 'bg-gray-100 text-gray-900') {
    return getColorClass(color, 'indicator', fallback);
}

export function getRowColorClass(color, fallback = '') {
    return getColorClass(color, 'row', fallback);
}

export function getCellColorClass(color, fallback = '') {
    return getColorClass(color, 'cell', fallback);
}

export { COLOR_CLASS_MAP };